/**
 * @file: responsiveness.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { DeviceType } from 'expo-device';
import { Platform, useWindowDimensions } from 'react-native';
import { useMediaQuery } from 'react-responsive';
import { isHubMode, useIsHub } from './isHub';
import { useDeviceType } from './useDeviceType';

export const useIsMobileLayout = () => {
  const matches = useMediaQuery({ maxWidth: 600 });
  const dimens = useWindowDimensions();
  const isHub = useIsHub();
  if (isHub) return false;
  const min = dimens.width < dimens.height ? dimens.width : dimens.height;
  return matches || min <= 600;
};

export const isMobileLayout = () => {
  return !isHubMode() && matchMedia('(max-width: 600px)').matches;
};

export const useIsWideDesktopLayout = () => {
  return useMediaQuery({ minWidth: 1366 });
};

export const useIsDesktopLayout = () => {
  // Treat anything wider than a typical phone as desktop. iPad mini/Air
  // portrait (768/820px) gets the sidebar shell; the sidebar itself
  // auto-collapses on those widths so it stays out of the way.
  const matches = useMediaQuery({ minWidth: 768 });
  const isHub = useIsHub();
  return !isHub && Platform.OS === 'web' && matches;
};

export const useIsMobilePhone = () => {
  return useIsMobileLayout() && Platform.OS !== 'web';
};

export const useIsTabletLayout = () => {
  return !useIsMobileLayout() && Platform.OS !== 'web';
};

export const useIsIpad = () => {
  const deviceType = useDeviceType();
  return deviceType === DeviceType.TABLET && Platform.OS === 'ios';
};

export const useIsTabletLandscapeLayout = () => {
  const deviceType = useDeviceType();
  const dimens = useWindowDimensions();
  return (
    (deviceType === DeviceType.TABLET || deviceType === DeviceType.DESKTOP) &&
    dimens.width > dimens.height
  );
};

export const useIsLandscape = () => {
  const dimens = useWindowDimensions();
  return dimens.width > dimens.height;
};

export const isMobileBrowser = () =>
  Platform.OS === 'web' &&
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
